import { render, staticRenderFns } from "./LabelCategorySettingsDropdown.vue?vue&type=template&id=5a58e380&scoped=true&"
import script from "./LabelCategorySettingsDropdown.vue?vue&type=script&lang=js&"
export * from "./LabelCategorySettingsDropdown.vue?vue&type=script&lang=js&"
import style0 from "./LabelCategorySettingsDropdown.vue?vue&type=style&index=0&id=5a58e380&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a58e380",
  null
  
)

export default component.exports